export const IDLE_DURATION = 1000 * 6; // 6 seconds

export enum VOLUME {
  MAX = 100,
  MIN = 0,
}
